import { Link } from 'react-router-dom';
import Reveal from '@/components/base/Reveal';

interface CaseData {
  eyebrow: string;
  icon: string;
  title: string;
  desc: string;
  points: string[];
  ctaLabel: string;
  ctaHref: string;
  image: string;
}

export default function LogisticsCase({ data }: { data: CaseData }) {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-50">
      <div className="max-w-[1200px] mx-auto">
        <Reveal>
          <div className="grid grid-cols-1 lg:grid-cols-[1fr_minmax(0,460px)] gap-6 lg:gap-10 items-stretch rounded-2xl border border-background-200 bg-background-100 overflow-hidden">
            <div className="p-6 md:p-9 flex flex-col">
              <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100 text-accent-900 text-xs font-semibold tracking-wide whitespace-nowrap w-fit">
                <i className={data.icon}></i>
                {data.eyebrow}
              </span>
              <h2 className="mt-4 font-heading font-bold text-xl md:text-2xl text-foreground-950 leading-snug">
                {data.title}
              </h2>
              <p className="mt-3 text-sm text-foreground-700 leading-relaxed">{data.desc}</p>

              <ul className="mt-6 flex flex-col gap-3">
                {data.points.map((p) => (
                  <li key={p} className="flex items-start gap-2.5">
                    <span className="w-5 h-5 shrink-0 mt-0.5 flex items-center justify-center rounded-full bg-primary-100 text-primary-700">
                      <i className="ri-check-line text-xs"></i>
                    </span>
                    <span className="text-sm text-foreground-700 leading-relaxed">{p}</span>
                  </li>
                ))}
              </ul>

              <div className="mt-8 pt-6 border-t border-background-200">
                <Link
                  to={data.ctaHref}
                  className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors hover:bg-primary-600"
                >
                  {data.ctaLabel}
                  <i className="ri-arrow-right-line text-base"></i>
                </Link>
              </div>
            </div>

            <div className="relative min-h-[240px] lg:min-h-full overflow-hidden">
              <img
                src={data.image}
                alt="ePin 食安码一物一码溯源档案"
                title="ePin 食安码可信数字身份"
                className="absolute inset-0 w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}